import { atom } from 'recoil';

export const ConfigureSelectedToggleKey = atom<{ [key: string]: boolean }>({
	key: 'configure-selected-toggle-key',
	default: {},
});
